import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Form, Input, Select, message, Upload, Spin, Modal, Drawer, Space } from 'antd';
import ImgCrop from 'antd-img-crop';
import moment from 'moment';
import PropTypes from 'prop-types';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import AccountFields from './DetailsPage/AccountDetailsField'
import RelatedTab from './DetailsPage/RelatedTab'
import AddDealPage from './AddDeals'
import AddTaskPage from './AddTask';
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import AccountRightData from './DetailsPage/AccountRightData'
import AccountIntePage from './DetailsPage/AccountIntePage'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { fetchDomainAvaliability, extractDomain } from "../../../Api/Services/CompanyApiService"
import { getStateData, getCityData, getCountryData, getRating, getAnnualRevenue, getNoofEmployee, getAllUsersData, IndustryData } from '../../../Api/Services/CommonApiService'
import { getOwnerChange, getCompanyAccount, FetchAllAccount, createAccounts, updateAccounts, FetchAllCustomerstatus, FetchAllOwnership, FetchAllAccountType, FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { getBaseURL } from '../../../Api/ApiConfig'
import Popup from '../Popup/ACMassPopup'
import NotesPopup from '../Popup/NotesPopup'
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import AllCancelPopup from '../Popup/AllCancelPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup';
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import { CancelIcon, ChangeOwnerIcon, CloneIcon, DealIcon, DeleteIcon, EditIcon, EmailIcon, MergeIcon, NotesIcon, ReportsIcon, SaveIcon, ShareIcon, TaskIcon } from '../../../components/Icons/Icons';
import { validateUrlField, nameOnChangeValidator, validateDescriptionField, validateZipCode, validateAddressLine } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const permission = localData.permissions
    const ProfileData = localData.profile
    const profile = ProfileData
    const [pages] = useState("Meeting")
    const [permissions] = useState(permission.entity);
    const [noofemployee, setNoofemployee] = useState([])
    const [revenue, setRevenue] = useState([])
    const [rating, SetRating] = useState([])
    const [accountIDs, setAccountIDs] = useState()
    const [updatePopup, setUpdatePopup] = useState(false)
    const [openOwnerPopup, setOpenOwnerPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [accountInitial, setAccountInitial] = useState()
    const [openOwnerContent, setOpenOwnerContent] = useState()
    const [edit, setEdit] = useState(false)
    const [createPages, setCratePages] = useState()
    const [trigger, setTrigger] = useState()
    const [approveOpen, setApproveOpen] = useState(false)
    const [accountId, setAccountId] = useState()
    const [displayData, setDisplayData] = useState()
    const [users, setUsers] = useState([])
    const [country, setCountry] = useState()
    const [mergeOpen, setMergeOpen] = useState(false)
    const [allCountry, setAllCountry] = useState([])
    const [image, setImage] = useState()
    const [approveCondition, setApproveCondition] = useState(false)
    const [deleteOption, setDeleteOpen] = useState(false);
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [checked, setChecked] = useState("Qualified")
    const [accountData, setAccountData] = useState([])
    const [createPageTask, setCreatePageTask] = useState()
    const [industryData, setIndustryData] = useState([])
    const [typeData, setTypeData] = useState([])
    const [ownerShipData, setOwnershipData] = useState([])
    const [companyId, setCompanyId] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [dataPermissions, setDataPermissions] = useState()
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [drawerPage, setDrawerPage] = useState()
    const [editField, setEditField] = useState(false)
    const [notePopup, setNotePopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [page, setPage] = useState()
    const [FILEList, setFileList] = useState([]);
    const [mailOpen, setMailOpen] = useState(false)
    const [sharePopup, setSharePopup] = useState(false)
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const [report, setReport] = useState()
    const [taskProp, setTaskProp] = useState()
    const [allList, setAllList] = useState([])
    const [popupMessage, setPopupMessage] = useState(false)
    const [accountTypeName, setAccountTypeName] = useState()
    const [emailAttendees, setEmailAttendees] = useState([])
    const [contactData, setContactData] = useState([])
    const [customerStatus, setCustomerStatus] = useState([])
    const [dataForDeal, setDataForDeal] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [openIntelligence, setOpenIntelligence] = useState(false);
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    // setTimeout(() => {
                    history.push('/Home/sponsors')
                    // getData(accountId); // This runs after 2 seconds
                    // }, 1000);
                }
            }
        });
    }
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const PageCancel = () => {
        history.push('/Home/sponsors')
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    const canShare = (dataPermissions, action) => {
        if (!dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasDataPermission;
    };
    // Update/Delete
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Sponsor number cannot exceed 15 characters")
            );
        }
        const getList = allList
            .filter(item => item.accountsId !== accountId)
        const existingCodes = getList.map(item => item.accountNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.accountNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyAccount()
            if (type === "Create") {
                const newCode = generateUniqueCode("AC", data);
                form.setFieldsValue({
                    accountnumber: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const getAllCustomerstatus = async () => {
        try {
            const data = await FetchAllCustomerstatus()
            const options = data.map((option, i) => (
                <Option value={option.customerStatus} key={i}>
                    {option.customerStatus}
                </Option>))
            setCustomerStatus(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data.map((option, i) => (
                <Option value={option.rating} key={i}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data.map((option, i) => (
                <Option value={option.annualRevenue} key={i}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.parent_organization) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.parent_organization);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.parentAccount, account_id: displayData?.parent_organization }];
                }
            }
            setAccountData(accountInfo)
        } catch (error) {
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            const options = data.map((option, i) => (
                <Option value={option.industryId} key={i}>
                    {option.industryName}
                </Option>));
            setIndustryData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function TypeDataApi() {
        try {
            const data = await FetchAllAccountType()
            let typeData;
            if (profile.roleName !== "Administrator") {
                typeData = data.filter((item) => item.accountTypeName === "Customer")
            } else {
                typeData = data
            }
            setTypeData(typeData)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function OwnerShipDataApi() {
        try {
            const data = await FetchAllOwnership()
            const options = data.map((option, i) => (
                <Option value={option.ownershipId} key={i}>
                    {option.ownershipName}
                </Option>));
            setOwnershipData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
            if (displayData.country) {
                const countryInfo = response.find(countrys => countrys.country === displayData.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(displayData, iso)
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function setInitialData(value) {
        setAccountInitial({
            accountnumber: normalizeValue(value.account_number),
            companyId: normalizeValue(value.company_id),
            accountName: normalizeValue(value.account_name),
            parentOrganization: normalizeValue(value.parent_organization),
            website: normalizeValue(value.website),
            accountType: normalizeValue(value.account_type),
            customerStatus: normalizeValue(value.customer_status),
            accountProfile: normalizeValue(value.account_profile),
            industry: normalizeValue(value.industry),
            ownership: normalizeValue(value.ownership),
            nomOfEmployees: normalizeValue(value.nom_of_employees),
            annualRevenue: normalizeValue(value.annual_revenue),
            accountFiles: (value.account_files || []),
            rating: normalizeValue(value.rating),
            description: normalizeValue(value.description),
            qualified: normalizeValue(value.qualified),
            accountOwner: normalizeValue(value.account_owner),
            country: normalizeValue(value.country),
            state: normalizeValue(value.state),
            city: normalizeValue(value.city),
            street: normalizeValue(value.street),
            postcode: normalizeValue(value.postcode),
        })
    }
    const setData = async (value) => {
        if (value !== undefined) {
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            setAssignOwner(value.account_owner)
            form.setFieldsValue({
                accountname: value.account_name,
                accountowner: value.account_owner,
                annualrevenue: value.annual_revenue,
                noofemployees: value.nom_of_employees,
                description: value.description,
                industry: value.industry,
                ownership: value.ownership,
                parentaccount: value.parent_organization,
                postcode: (value.postcode === "0" || value.postcode === 0) ? null : value.postcode,
                rating: value.rating,
                street: value.street,
                type: value.account_type,
                websiteUrl: value.website,
                country: value.country,
            })
            if (drawerPage !== "CloneLead") {
                form.setFieldsValue({
                    accountnumber: value.account_number,
                })
            }
            if (value.account_type_name === "Customer") {
                setAccountTypeName(value.account_type_name)
                form.setFieldsValue({ customerStatus: value.customer_status })
            }
            else {
                form.setFieldsValue({ customerStatus: null })
            }
            if (value?.website) {
                getAccountReports(value?.website)
            } else {
                setReport({ allow: false, data: null })
            }
            setFileList(value.account_files || [])
            setChecked(value.qualified)
            setAccountId(value.account_id)
            setCompanyId(value.company_id)
            setImage(value.account_profile)
            setDeleteOpen(value.account_profile && value.account_profile !== "")
            setStates({
                ...states,
                selectedRowKeys: [value.account_id]
            });
            setCountry(value.country)
        }
    }
    async function deleteMenu(ids) {
        setAccountIDs([ids])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    async function getContactData(id) {
        try {
            const response = await FetchContactByAccount(id)
            setContactData(response)
        } catch (error) {
            message.error(error);
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }

    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner(null)
        form.setFieldsValue({
            accountname: null,
            accountowner: null,
            annualrevenue: null,
            noofemployees: null,
            description: null,
            industry: null,
            ownership: null,
            parentaccount: null,
            postcode: null,
            rating: null,
            street: null,
            type: null,
            websiteUrl: null,
            country: null,
            customerStatus: null
        })
        setFileList([])
        setChecked()
        setCompanyId()
        setImage()
        setDeleteOpen(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut") {
            setCratePage()
        }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData(id) {
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await FetchAccountDetails(id);
                const response = responseData.data
                getSharingPermissions(undefined)
                setData(response);
                setAccountInitial(InitialData.AccountData)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            } else {
                const responseDataRES = await FetchAccountDetails(id)
                if (!responseDataRES.allow) throw new Error();
                const response = responseDataRES.data
                getSharingPermissions(response?.sharingPermission?.sharePermission)
                setData(response);
                setInitialData(response)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(id, hideMessage, isAutomation, updateResponse) {
        try {
            const responseDataRES = await FetchAccountDetails(id)
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Sponsor <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successful
                    </span>
                );
            }
            if (!responseDataRES.allow) throw new Error();
            const response = responseDataRES.data
            getSharingPermissions(response?.sharingPermission?.sharePermission)
            setData(response);
            setInitialData(response)
            const transformedItem = {
                ...response,
                created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Sponsor <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successful
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                dataFound = true;
                setAccountId(response)
                getData(response)
                getContactData(response)
                getList("Update")
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setAccountIDs([accountId])
            setUpdatePopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Account",
            ids: [id]
        })
    }
    const CreateMail = async () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            try {
                const allEmails = contactData
                    .map(c => ({
                        id: c.contacts_id,
                        type: "Contacts"
                    }));
                // .map(c => c?.email)
                // .filter(email => email);
                setNaCTrigger("trigger")
                setEmailAttendees(allEmails);
                setMailOpen(true)
            } catch (error) {
                message.error(error);
            }
        }
    }
    const onAccountTypeChange = (value, option) => {
        setAccountTypeName(option.key)
        if (option.key !== "Customer" && value !== 1) {
            form.setFieldsValue({
                customerStatus: null,
                accountowner: null,
                parentaccount: null,
                rating: null,
                industry: null
            });
            if (option.key === "Competitor") {
                form.setFieldsValue({
                    industry: 23,
                });
            }
        }
        else if (option.key === "Customer" && value === 1) {
            form.setFieldsValue({
                customerStatus: "Prospective Customer",
                industry: null
            });
        }
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    accountowner: profile.userId
                });
            }
            setCompanyId(profile.companyId)
        }
    }
    useEffect(() => {
        if (FromPage) {
            scroolup();
        }
    }, [FromPage])
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            getCountry(),
            getRatingData(),
            getAllCustomerstatus(),
            getAnnualRevenueData(),
            getNomEmployeeData(),
            UserDetailsApi(),
            IndustryDataApi(),
            TypeDataApi(),
            OwnerShipDataApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        const isCloneLead = drawerPage === "CloneLead";
        if (
            !isCloneLead &&
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                if (drawerPage === "CloneLead") {
                    getData(accountId)
                    setDataPermissions("Read,Update,Delete,Sharing")
                    setEditField(true)
                    setEdit(true)
                    getList("Create")
                }
                else {
                    getEntityAvalibitlity()
                }
            }
            else {
                form.setFieldsValue({
                    accountname: undefined,
                    accountowner: undefined,
                    annualrevenue: undefined,
                    noofemployees: undefined,
                    description: undefined,
                    industry: undefined,
                    ownership: undefined,
                    parentaccount: undefined,
                    postcode: undefined,
                    rating: undefined,
                    street: undefined,
                    websiteUrl: undefined,
                    country: undefined,
                })
                setFileList([])
                setChecked()
                setAccountId()
                setImage()
                setDeleteOpen(false)
                setCountry()
                setState()
                setCity()
                getUserDetail()
                getList("Create")
                setDisplayData("Create")
                setAccountInitial(InitialData.AccountData)
                setDataPermissions("Read,Update,Delete,Sharing")
                setAccountTypeName("Customer")
                form.setFieldsValue({
                    type: 1,
                    customerStatus: "Prospective Customer"
                })
                setEdit(true)
                setEditField(true)
            }
        }
    }, [UrlId, FromPage, drawerPage]);
    const OwnerChecking = async (value) => {
        if (value && value !== displayData?.account_owner) {
            try {
                const Response = await getOwnerChange(displayData?.account_owner, accountId)
                if (Response === "") {
                    setOpenOwnerPopup(false)
                }
                else {
                    setOpenOwnerPopup(true)
                    setOpenOwnerContent(Response)
                }
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const handleOpenOwnerPopup = () => {
        setOpenOwnerPopup(false)
        form.setFieldsValue({
            accountowner: displayData?.account_owner
        })
    }
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            setEditField(true)
            setEdit(true)
            dispatch(setEditCall(true))
            setTrigger("");
            setApproveOpen(false)
        }
    }
    const createDeal = (Aid) => {
        setNaCTrigger("trigger")
        setCratePages("AccountPage")
        setDataForDeal({ AccountId: Aid })
    }
    const CloneLead = () => {
        setDrawerPage("CloneLead")
    }
    const handleMergeclick = () => {
        if (approveCondition) {
            setApproveOpen(true)
            setMergeOpen(false)
        }
        else {
            setNaCTrigger("trigger")
            setApproveOpen(false)
            setMergeOpen(true)
        }
    }
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const moreAction = accountTypeName === "Customer" ? "Yes" : "No"
    const MoreAction = ({ closeDropdown }) => (accountTypeName === "Customer" ?
        <div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl} onClick={!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${(canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2010)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2010)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? () => { handleMergeclick(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl} onClick={(!edit && report?.allow) ? () => { openTacking(); closeDropdown() } : undefined} className={`text_icon ${(!edit && report?.allow) ? "" : 'disabled_link'}`}>
                <ReportsIcon height={15} width={15} marginRight={5} /> Intelligence Report
            </Link>
        </div > : <></>
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CreateMail()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CreateTask(accountId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(accountId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Clone'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CloneLead()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CloneLead()
                    }
                }}
                aria-label='clone'
            > <CloneIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(edit || !canShare(dataPermissions, "Sharing")) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Share'
                onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => HandleShareClick()}
                onKeyDown={(event) => {
                    if (canShare(dataPermissions, "Sharing") && (event.key === 'Enter' || event.key === ' ')) {
                        HandleShareClick()
                    }
                }}
                aria-label='share'
            > <ShareIcon height={20} width={20} /></div>
        },
    ]
    let FinalActions = [...ButtonActions];
    if (accountTypeName !== "Customer") {
        FinalActions = FinalActions.slice(2, -1);
        FinalActions.push({
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Add a Note'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => handleNoteClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        handleNoteClick("Create")
                    }
                }}
                aria-label='notes'
            > <NotesIcon height={20} width={20} /></div>
        }, {
            Actions: <div className={(!canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Merge Duplicates'
                onClick={(!canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? undefined : () => handleMergeclick()}
                onKeyDown={(event) => {
                    if (canUpdateDelete(permissions, dataPermissions, "Update", 2011) && (event.key === 'Enter' || event.key === ' ')) {
                        handleMergeclick()
                    }
                }}
                aria-label='merge'
            > <MergeIcon height={20} width={20} /></div>
        }, {
            Actions: <div className={(!report?.allow) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Intelligence Report'
                onClick={(!report?.allow) ? undefined : () => handleMergeclick()}
                onKeyDown={(event) => {
                    if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                        handleMergeclick()
                    }
                }}
                aria-label='intelligence'
            > <ReportsIcon height={20} width={20} /></div>
        });
    }
    const LeadInfos = {
        profile: image,
        Classname: "AccountIcon",
        letterIcon: displayData?.account_name,
        name: `${displayData?.account_name}`,
        subName: displayData?.account_number && displayData?.account_number !== "" ? displayData?.account_number : "Sponsor Number",
        mainAction: accountTypeName === "Customer" ? <>
            <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={() => createDeal(displayData?.account_id)} disabled={!canCreate(permissions, 2014)}>
                <DealIcon height={25} width={25} /> Create Proposal
            </Button>
        </> : undefined,
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], accountId] : null), [UrlId, accountId]);
    const getDetailsDatas = useCallback(() => getData(accountId), [accountId]);
    const LeadDetails = (<AccountFields displayData={displayData} />);
    const RelatedDetails = (<RelatedTab EntityType={accountTypeName === "Customer" ? "Account" : "Account1"} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} disabledData={!canCreate(permissions, 2014)} displayData={displayData} disabledData2={!canCreate(permissions, 2006)} trigger={trigger} ownerId={displayData?.account_owner} />)
    const RightRelatedDetails = (<AccountRightData displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} conditionApply={accountTypeName} trigger={trigger} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const {
            accountnumber,
            accountname,
            accountowner,
            annualrevenue,
            noofemployees,
            description,
            industry,
            ownership,
            parentaccount,
            postcode,
            rating,
            street,
            type,
            customerStatus,
            websiteUrl
        } = values;
        const payload = {
            accountNumber: normalizeValue(accountnumber),
            companyId: normalizeValue(companyId),
            accountName: normalizeValue(accountname),
            parentOrganization: normalizeValue(parentaccount),
            website: normalizeValue(websiteUrl),
            accountType: normalizeValue(type),
            customerStatus: normalizeValue(accountTypeName === "Customer" ? customerStatus : null),
            accountProfile: normalizeValue(image),
            industry: normalizeValue(industry),
            ownership: normalizeValue(ownership),
            nomOfEmployees: normalizeValue(noofemployees),
            annualRevenue: normalizeValue(annualrevenue),
            accountFiles: FILEList,
            rating: normalizeValue(rating),
            description: normalizeValue(description),
            qualified: normalizeValue(checked),
            accountOwner: normalizeValue(accountowner),
            country: normalizeValue(country),
            state: normalizeValue(state),
            city: normalizeValue(city),
            street: normalizeValue(street),
            postcode: normalizeValue((postcode && postcode !== "") ? Number(postcode) : undefined),
        }
        const updatedFields = getChangedFields(payload, accountInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(accountId)
            scroolup()
            message.success("Sponsor updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await updateAccounts(updatedFields, accountId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.account_owner !== accountowner;
                        if (isApproval) {
                            hideMessage();
                            getData(accountId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Sponsor <strong>{response?.data?.[0]?.entityName}</strong> has been updated successful
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/sponsors');
                        }
                        else {
                            getData1(accountId, hideMessage, isAutomation, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createAccounts(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data?.message === AutomationMessage;
                    const isApproval = response?.data?.message === ApprovalMessage;
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data?.message);
                    } else {
                        message.success(response?.data?.message);
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(error)
        }
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(accountId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity")
    }
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} canUpdateDelete={canUpdateDelete}
                                UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2011 }} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={FinalActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Sponsor" :
                            <span>
                                Update Sponsor
                                {displayData?.account_name && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {displayData?.account_name}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Sponsor"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (edit && uiReady) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {(FromPage === "EntityUpdate" && drawerPage !== "CloneLead") ?
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2012) || deleteClick || doubleClick} loading={deleteClick}
                                    className="red-button" size="small"
                                    onClick={() => deleteMenu(accountId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(displayData && uiReady) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <Heading as="h5">Sponsor Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Sponsor Name" name="accountname" id="accountname"
                                                                    rules={[{ required: true, message: 'Please enter sponsor name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Sponsor Name" /></Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Number" name="accountnumber" id="accountnumber"
                                                                    rules={[{ required: true, message: 'Please enter sponsor number', }, { validator: validateCode }]}>
                                                                    <Input placeholder="Sponsor Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Parent Sponsor" name="parentaccount" id="parentaccount">
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Parent Sponsor"
                                                                        showSearch disabled={accountTypeName !== "Customer"}
                                                                        allowClear onChange={(value) => form.setFieldsValue({ parentaccount: value || null })}
                                                                        optionFilterProp="children" optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                    >
                                                                        {accountData.filter(item => item.account_type_name === "Customer" && item.account_id !== displayData?.account_id).map((option, i) => (
                                                                            <Option value={option.account_id} key={i} label={(
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div className='Div_flex2'>
                                                                                        <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" />
                                                                                                :
                                                                                                <span className="image_icon AccountIcon">
                                                                                                    {option.account_name.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <span className='div-ellipsis'>{option.account_name}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)}>
                                                                                <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                    <div>
                                                                                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                            < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.account_name.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }</div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                        <p style={{ margin: 0 }}>{option?.account_number}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Owner" name="accountowner" id="accountowner"
                                                                    rules={accountTypeName === "Customer" ? [{ required: true, message: 'Please select a sponsor owner' }] : [{ required: false }]}>
                                                                    <Select style={{ width: '100%' }} onChange={UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ? (value) => OwnerChecking(value) : undefined}
                                                                        placeholder="Select Sponsor Owner"
                                                                        showSearch disabled={accountTypeName !== "Customer"}
                                                                        optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Type" name="type" id="type"
                                                                    rules={[{ required: true, message: 'Please select an Sponsor type', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Type"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        onChange={onAccountTypeChange}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {typeData.map((option, i) => (
                                                                            <Option value={option.accountTypeId} key={option.accountTypeName} index={i}>
                                                                                {option.accountTypeName}
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Url" name="websiteUrl"
                                                                    id="websiteUrl" rules={[{ required: true, message: 'Please enter sponsor url' }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateUrlField(value, 2000);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Sponsor Url" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Industry" name="industry"
                                                                    id="industry" rules={[{ required: true, message: 'Please enter industry' }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Industry"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {industryData}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Ownership" name="ownership" id="ownership" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Ownership"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ ownership: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {ownerShipData}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="No of Employees" name="noofemployees" id="noofemployees" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select No of Employees"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ noofemployees: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {noofemployee}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Annual Revenue (USD)" name="annualrevenue" id="annualrevenue" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Annual Revenue"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ annualrevenue: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {revenue}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Rating" name="rating" id="rating" >
                                                                    <Select style={{ width: '100%' }} disabled={accountTypeName !== "Customer"}
                                                                        placeholder="Select Rating"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ rating: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {rating}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            {accountTypeName === "Customer" &&
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Customer Status" name="customerStatus" id="customerStatus" >
                                                                        <Select style={{ width: '100%' }}
                                                                            placeholder="Select Status"
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {customerStatus}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            }
                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Description" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Address Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]}>
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select Country"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCountryChange}
                                                                        value={country}
                                                                    >
                                                                        {allCountry?.map((option) => (
                                                                            <Option key={option.countryId} value={option.country}>
                                                                                {option.country}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="State" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch allowClear
                                                                        placeholder="Select State"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleStateChange}
                                                                        value={state}
                                                                    >
                                                                        {allState?.map((option) => (
                                                                            <Option key={option.stateId} value={option.state}>
                                                                                {option.state}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="City" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch allowClear
                                                                        placeholder="Select City"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCityChange}
                                                                        value={city}
                                                                    >
                                                                        {allCity?.map((option) => (
                                                                            <Option key={option.cityId} value={option.city}>
                                                                                {option.city}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Street name and No" name="street" id="street" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateAddressLine(value, 100);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Street name and no" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateZipCode(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Zip Code" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        <Heading as="h5">Profile Picture</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <figure className="photoUpload align-center-v" >
                                                                    {image !== null && image !== undefined && image !== "" ?
                                                                        < img src={image} alt="" />
                                                                        :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ?
                                                                            <span className='details_span_Tag AccountIcon'>
                                                                                {displayData?.account_name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            :
                                                                            <span className='details_span_Tag AccountIcon'>
                                                                                A
                                                                            </span>
                                                                    }
                                                                    {edit && <figcaption>
                                                                        {deleteOption ? (
                                                                            <div className='delete-div'>
                                                                                <span className='delete-span'>
                                                                                    <FeatherIcon icon="trash-2" size={16} onClick={handleDeleteImage} />
                                                                                </span>
                                                                            </div>) :
                                                                            (<div><ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                                <Upload {...FileUpload}>
                                                                                    <Link className="btn-upload" to={combinedUrl}>
                                                                                        <FeatherIcon icon="camera" size={16} />
                                                                                    </Link>
                                                                                </Upload></ImgCrop>
                                                                            </div>)
                                                                        }
                                                                    </figcaption>}
                                                                </figure>
                                                            </Col>
                                                        </Row>
                                                        {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" && drawerPage !== "CloneLead") && <>
                                                            <Heading as="h5">Other Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created Date" >
                                                                        <span >{displayData?.created_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                            uploadedById: displayData?.created_by,
                                                                            uploadedProfile: displayData?.createdByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified Date" >
                                                                        <span >{displayData?.modified_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                            uploadedById: displayData?.modified_by,
                                                                            uploadedProfile: displayData?.modifiedByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row >
                                                        </>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Account" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <AddDealPage UrlId={undefined} FromPage={createPages} setCratePage={setCratePages} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Accounts" entity="EntityPages" toId={emailAttendees} AccountId={accountId} CallBackTrigger={setNaCTrigger} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Account" sharingIds={[accountId]} PageTypes="Single" />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} accountIDs={accountIDs} popupType={popupType} action={action} assignOwner={assignOwner} GetAll={getDetailsDatas} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            <MergePage meetingOpen={mergeOpen} deletecheck={!hasRoleDeletePermission(permissions, 2012)} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Accounts" setNaCTrigger={setNaCTrigger} PryData={displayData} />
            {openOwnerPopup && <Modal
                title="Update sponsor owner?"
                open={openOwnerPopup}
                onCancel={handleOpenOwnerPopup}
                footer={[<div className="form_action_button">
                    <Button size="small" onClick={handleOpenOwnerPopup} className="button_colors">
                        <FeatherIcon icon="check" /> Ok
                    </Button>
                </div>]}
                maskClosable={false}
            > {openOwnerContent}
            </Modal>}
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
};
export default AddNew;
